import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  gallery_img: {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  gallery_item: {
    margin: 0,
    position: 'relative',
    overflow: 'hidden',
    '& .title': {
      color: '#fff',
      position: 'absolute',
      fontWeight: '400',
      fontSize: '28px',
      lineHeight: '41px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'uppercase',
      textShadow: '0px 1px 5px rgba(0, 0, 0, 0.2)'
    },
    '& .cat-btn': {
      position: 'absolute',
      minWidth: '130px',
      textAlign: 'center',
      borderRadius: '8px',
      fontSize: '12px',
      textTransform: 'uppercase',
      left: '20px',
      bottom: '20px',
      color: '#fff',
      backgroundColor: '#014f93',
      border: 'none',
      padding: '8px 20px',
      textDecoration: 'none',
      display: 'inline-block',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      '&:hover': {
        backgroundColor: '#000'
      }
    }
  },
  gallery_item1: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    gridRowStart: 2,
    gridRowEnd: 2,
    '& .title': {
      bottom: '60px',
      left: '20px'
    }
  },
  gallery_item2: {
    gridColumnStart: 1,
    gridColumnEnd: 1,
    gridRowStart: 1,
    gridRowEnd: 1,
    '& .title': {
      left: '20px',
      bottom: '60px'
    }
  },
  gallery_item3: {
    gridColumnStart: 2,
    gridColumnEnd: 2,
    gridRowStart: 1,
    gridRowEnd: 1,
    '& .title': {
      bottom: '60px',
      right: '20px'
    },
    '& .cat-btn': {
      left: 'auto',
      right: '20px'
    }
  },
  gallery_mobile_img: {
    width: '100%',
    height: '100%',
    maxHeight: '520px',
    maxWidth: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  gallery_mobile_item: {
    margin: '0 0 20px',
    position: 'relative',
    height: '520px',
    overflow: 'hidden',
    '& .title': {
      color: '#fff',
      position: 'absolute',
      fontWeight: '400',
      fontSize: '28px',
      lineHeight: '41px',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      textTransform: 'uppercase',
    },
    '& .cat-btn': {
      position: 'absolute',
      minWidth: '130px',
      textAlign: 'center',
      borderRadius: '8px',
      fontSize: '12px',
      textTransform: 'uppercase',
      left: '20px',
      bottom: '20px',
      color: '#fff',
      backgroundColor: '#014f93',
      border: 'none',
      padding: '8px 20px',
      textDecoration: 'none',
      display: 'inline-block',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      '&:hover': {
        backgroundColor: '#000'
      }
    }
  },
  gallery_mobile_item1: {
    '& .title': {
      bottom: '60px',
      left: '20px'
    }
  },
  gallery_mobile_item2: {
    '& .title': {
      left: '20px',
      bottom: '60px'
    }
  },
  gallery_mobile_item3: {
    '& .title': {
      bottom: '60px',
      right: '20px'
    },
    '& .cat-btn': {
      left: 'auto',
      right: '20px'
    }
  }
}));

const CTAPreviewImages: React.FC<CTAPreviewImagesProps> = ({ values, mobileView }) => {
  const classes = useStyles();

  return (
    <>
      <figure
        className={`
          ${mobileView ? classes.gallery_mobile_item : classes.gallery_item}
          ${mobileView ? classes.gallery_mobile_item2 : classes.gallery_item2}
        `}
      >
        <img
          src={
            mobileView
              ? values?.horizontal_top['dermpro/design/cta_image_2_mobile_lite']
              : values?.horizontal_top['dermpro/design/cta_image_2_desktop_lite']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 2"
        />
        <div className="title">
          {values?.horizontal_top['store_info/cta/cta_horizontal_top_title']}
        </div>
        <div className="cat-btn action primary" title="View All">View All</div>
      </figure>
      <figure
        className={`
          ${mobileView ? classes.gallery_mobile_item : classes.gallery_item}
          ${mobileView ? classes.gallery_mobile_item3 : classes.gallery_item3}
        `}
      >
        <img
          src={
            mobileView
              ? values?.horizontal_bottom['dermpro/design/cta_image_3_mobile_lite']
              : values?.horizontal_bottom['dermpro/design/cta_image_3_desktop_lite']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 3"
        />
        <div className="title">
          {values?.horizontal_bottom['store_info/cta/cta_horizontal_bottom_title']}
        </div>
        <div className="cat-btn action primary" title="View All">View All</div>
      </figure>
      <figure
        className={`
          ${mobileView ? classes.gallery_mobile_item : classes.gallery_item}
          ${mobileView ? classes.gallery_mobile_item1 : classes.gallery_item1}
        `}
      >
        <img
          src={
            mobileView
              ? values?.vertical['dermpro/design/cta_image_1_mobile_lite']
              : values?.vertical['dermpro/design/cta_image_1_desktop_lite']
          }
          className={mobileView ? classes.gallery_mobile_img : classes.gallery_img}
          alt="CTA 1"
        />
        <div className="title">
          {values?.vertical['store_info/cta/cta_vertical_title']}
        </div>
        <div className="cat-btn action primary" title="View All">View All</div>
      </figure>
    </>
  );
};

export default CTAPreviewImages;
